import { ProductReviewsRatingStars } from '@/app/product/[slug]/_components/product-reviews/rating/stars'

type Props = {
  reviewAvg: number
  reviewCount: number
}

export const ProductReviewsRating = ({ reviewAvg, reviewCount }: Props) => {
  const rawRating = reviewAvg > 5 ? reviewAvg / 2 : reviewAvg
  const rating = Math.floor(rawRating * 10) / 10

  return (
    <>
      <div className='flex items-baseline gap-1.5 lg:items-center lg:gap-3'>
        <p className='font-criteria text-[40px] font-medium leading-7 text-neutral-900 lg:text-[80px] lg:leading-14'>
          {rating}
        </p>
        <div>
          <ProductReviewsRatingStars rating={rawRating} />
          <p className='mt-1 font-sans text-sm leading-4.5 text-neutral-500 max-lg:hidden'>
            Dựa trên {reviewCount} đánh giá đến từ khách hàng
          </p>
        </div>
      </div>
      <p className='mt-1 font-sans text-xs text-neutral-500 lg:hidden'>
        Dựa trên {reviewCount} đánh giá đến từ khách hàng
      </p>
    </>
  )
}
